import useCitySEO from "../city-template/components/CitySEO";
import CityHeroSection from "../city-template/components/CityHeroSection";
import CityStickyNav from "../city-template/components/CityStickyNav";
import CityServicesSection from "../city-template/components/CityServicesSection";
import CityLocalAreaSection from "../city-template/components/CityLocalAreaSection";
import CityTestimonialsSection from "../city-template/components/CityTestimonialsSection";
import CityAcceptanceFacilitiesSection from "../city-template/components/CityAcceptanceFacilitiesSection";
import CityComparisonSection from "../city-template/components/CityComparisonSection";
import CityMistakesSection from "../city-template/components/CityMistakesSection";
import CityHowItWorksSection from "../city-template/components/CityHowItWorksSection";
import CityFAQSection from "../city-template/components/CityFAQSection";
import CityHelpfulResourcesSection from "../city-template/components/CityHelpfulResourcesSection";
import CityFinalCTA from "../city-template/components/CityFinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import StocktonProcessingTimeSection from "./components/StocktonProcessingTimeSection";
import { stocktonConfig } from "./data";

export default function StocktonPage() {
  return (
    <div className="font-sans">
      <CityHeroSection
        city={stocktonConfig.city}
        h1={stocktonConfig.h1}
        subtitle={stocktonConfig.heroSubtitle}
        imageUrl={stocktonConfig.heroImageUrl}
        imageAlt={stocktonConfig.heroImageAlt}
      />
      <CityStickyNav links={stocktonConfig.stickyNavLinks} />
      <StocktonProcessingTimeSection />
      <CityServicesSection city={stocktonConfig.city} services={stocktonConfig.services} />
      <CityLocalAreaSection
        city={stocktonConfig.city}
        state={stocktonConfig.state}
        cities={stocktonConfig.nearbyCitiesZips}
        benefits={stocktonConfig.benefits}
        internalLinks={stocktonConfig.internalLinks}
        officeNote={stocktonConfig.fpcOfficeNote}
        officeDistance={stocktonConfig.fpcOfficeDistance}
        serviceAreaIntro={stocktonConfig.serviceAreaIntro}
        nearbyCitiesIntro={stocktonConfig.nearbyCitiesIntro}
      />
      <CityTestimonialsSection city={stocktonConfig.city} testimonials={stocktonConfig.testimonials} intro={stocktonConfig.testimonialsIntro} />
      <CityAcceptanceFacilitiesSection city={stocktonConfig.city} facilities={stocktonConfig.facilities} />
      <CityComparisonSection city={stocktonConfig.city} regionalAgency={stocktonConfig.regionalAgency} rows={stocktonConfig.comparisonRows} />
      <CityMistakesSection city={stocktonConfig.city} mistakes={stocktonConfig.mistakes} intro={stocktonConfig.mistakesIntro} />
      <CityHowItWorksSection city={stocktonConfig.city} steps={stocktonConfig.steps} intro={stocktonConfig.howItWorksIntro} />
      <CityFAQSection city={stocktonConfig.city} faqs={stocktonConfig.faqs} intro={stocktonConfig.faqIntro} />
      <CityHelpfulResourcesSection
        city={stocktonConfig.city}
        photoLocations={stocktonConfig.photoLocations}
        dmvLocations={stocktonConfig.dmvLocations}
        airports={stocktonConfig.airports}
      />
      <SEOCrossLinks currentRoute={stocktonConfig.route} state={stocktonConfig.stateAbbr} showCities={false} />
      <CityFinalCTA />
    </div>
  );
}